import { cloneElement, isValidElement, ReactNode } from 'react';

import { twMerge } from '@/core/tamagoshiTailwind/util/twMerge';

type RestrictedReactNodeOrElementProps = {
  element: ReactNode;
  className?: string;
};
export const RestrictedReactNodeOrElement = ({
  element,
  className,
}: RestrictedReactNodeOrElementProps) => {
  if (isValidElement<{ className?: string }>(element)) {
    return cloneElement(element, {
      className: twMerge(element.props.className, className), // REVIEW NOTE: I'm not sure about this implementation with Tailwind
    });
  }

  if (element !== undefined) {
    return <span className={className}>{element}</span>;
  }

  return element;
};

RestrictedReactNodeOrElement.displayName = 'RestrictedReactNodeOrElement';
